import { store } from 'redux/store';
import { authInitState } from 'redux/reducers/auth/reducer';
import { getClientAccessRequest } from 'redux/reducers/paymentMethods/reducer';
import { REDIRECT_URL } from 'services/constants/env';
import { PATHS } from 'routes/constants';
import { endpoint } from 'services/endpoint';
import { isClientAccessBlockedError } from 'utils/apiError';
import { IAxiosError, IAxiosRequestConfig } from './types';

// ==========================================:
export const onError = (error: IAxiosError) => {
	const status = error.response ? error.response.status : null;
	const errorResponse = error.config as IAxiosRequestConfig | undefined;
	const state = store.getState();

	const host = document.location.hostname;
	const hostKeycloak =
		host === 'dashboard.easproject.com' ? 'id.easproject.com' : 'id-dev.easproject.com';

	const ID_URL = `https://${hostKeycloak}/auth/realms/dashboard/protocol/openid-connect/auth?response_type=code&client_id=dashboard-ui&redirect_uri=${
		REDIRECT_URL ?? 'http://localhost:3000'
	}`;

	// window.location.assign(ID_URL);

	// 401 при обмене кода обрабатывается в саге; сброс состояния здесь
	// затирает токены параллельного успешного connect и зацикливает логин
	const isConnectRequest = errorResponse?.url?.includes(endpoint.auth.CONNECT);
	// a background request (header banner): its 401 must not sign the user out on every page
	const isBackgroundRequest = !!errorResponse?.skipAuthRedirect;

	// 423 of the payment gateway: the call is blocked by the operator. Not an auth error: the caller shows the `message`
	// of the body (getErrorMessage); the restrictions are re-read so the page switches to read-only.
	if (
		isClientAccessBlockedError(error) &&
		!errorResponse?.url?.includes(endpoint.paymentMethods.CLIENT_ACCESS)
	) {
		store.dispatch(getClientAccessRequest());
	}

	if (
		status === 401 &&
		errorResponse &&
		!errorResponse._retry &&
		!isConnectRequest &&
		!isBackgroundRequest
	) {
		// console.log('onError 401', state.auth);
		// store.dispatch(saveUrl(window.location.pathname + window.location.search));
		if (state.auth?.inactivityLogout) {
			// store.dispatch(authInitState());
			window.location.href = PATHS.INACTIVITY_PAGE;
		} else {
			store.dispatch(authInitState());
			window.location.assign(ID_URL);
		}
	}

	return Promise.reject(error);
};
